$(document).ready(function() {
    $('#accordion-button-1').attr('aria-expanded', 'true');
});


// product page click on review and scroll down review slider section
jQuery(document).ready(function($) {
    $('.sc-6p36wj-1.JBHcH.reputon-container').on('click', function() {
        $('html, body').animate({
            scrollTop: $('#shopify-block-amazon_reviews_carousel_widget_block_product_ULiYNt').offset().top
        }, 1000); // Duration of the scroll animation in milliseconds
    });
});

// $('.slider-content ul').slick({
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   dots: true,
//   arrows: true,
//   responsive: [
//       {
//           breakpoint: 991,
//           settings: {
//              slidesToShow: 1,
//           }
//       },
//       {
//           breakpoint: 767,
//           settings: {
//               slidesToShow: 1,
//           }
//       }
//   ]
// });







  if ($(window).width() <= 768) {

    
     
    $('.tabss ul').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.mobile-slider-content',
      dots: false,
      centerMode: true,
      arrows: false,
      infinite: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

   
     $('.tabss .mobile-slider-content').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.tab-slider-mobile',
      dots: false,
      fade: true,
      centerMode: false,
      arrows: true,
      infinite: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });
      
     
   

    // $('.mobile-slider-content').slick({
    //   slidesToShow: 1, 
    //   slidesToScroll: 1,
    //   asNavFor: '.tabss ul', 
    //   dots: false,
    //   centerMode: false,
    //   infinite: true,
    //   focusOnSelect: true,
    //   arrows: false,
    // });


    

  }


if ($(window).width() >= 768) {
$('.tabs-contents').hide();
$('.tabs-contents:first').show();

// Click function
$('#tabss-nav li').click(function(){
  $('#tabss-nav li').removeClass('active');
  $(this).addClass('active');
  $('.tabs-contents').hide();
  
  var activeTab = $(this).find('a').attr('href');
  $(activeTab).show();
  return false;
});

}




$(function() {
    setInterval(function() {
      var $pricetext = $('.product__info-container .price--large').find('.price__sale').html();
      $('.custom-price').html($pricetext);
    },2);
});



// $(document).ready(function() {
//   $('.read-more-toggle').click(function(event) {
//     event.preventDefault(); // Prevent default link behavior
//     var $fullDescription = $(this).siblings('.full-description');
    
//     // Toggle the full description's visibility
//     $fullDescription.slideToggle();

//     // Toggle the button text between "Read More" and "Read Less"
//     if ($(this).text() === 'Read More') {
//       $(this).text('Read Less');
//     } else {
//       $(this).text('Read More');
//     }
//   });
// });


document.addEventListener('DOMContentLoaded', function() {
    var readMoreLink = document.querySelector('.read-more-toggle');
    var fullText = document.querySelector('.full-description');
    var excerpt = document.querySelector('.short-description');
    
    if (readMoreLink) {
        readMoreLink.addEventListener('click', function(e) {
            e.preventDefault();
            if (fullText.style.display === 'none') {
                fullText.style.display = 'inline';
                excerpt.style.display = 'none';
                this.textContent = 'Read Less';
            } else {
                fullText.style.display = 'none';
                excerpt.style.display = 'inline';
                this.textContent = 'Read More';
            }
        });
    }
});




$(document).ready(function () {
  $('.Choose.Option .box').on('click', function () {
    
    // const courseText = $(this).find('.jar-count').text();
    // const mindText = $(this).find('.mild_to_moderate').text();
    const titleText = $(this).find('.mo-title-inline .title').text();
    const combinedText = `${titleText}`;
    
    $('.change-var-title ul li').text(titleText);
  });
});



// $(document).ready(function () {
  
//   $('.change-var-title ul li:first-child').addClass('active');
 
//   $('.Choose.Option .box').on('click', function () {
    
//     const index = $(this).index('.Choose.Option .box');

//     $('.change-var-title ul li').removeClass('active');

//     $('.change-var-title ul li').eq(index).addClass('active');
//   });
// });


$(document).ready(function () {
  
  if (window.location.search.includes('variant=')) {
    const urlWithoutVariant = window.location.href.split('?')[0];
    window.history.replaceState(null, null, urlWithoutVariant);
  }


  const $variantRadios = $('input[name="Choose an Option"]'); // Selector for variant radio buttons
  const $swatchElements = $('.box'); // Selector for all swatch elements

  // Uncheck all radio buttons for swatches
  if ($variantRadios.length) {
    $variantRadios.prop('checked', false);
  }

  // Remove the active state from all swatches
  if ($swatchElements.length) {
    $swatchElements.removeClass('selected');
  }

  // 3. Select the first variant swatch and mark it as active
  const $firstSwatch = $('.box:first');
  if ($firstSwatch.length) {
    $firstSwatch.addClass('selected'); // Add the selected class
    $firstSwatch.find('input[name="Choose an Option"]').prop('checked', true); // Check the first radio button
  }
});

$(document).ready(function () {
  
  if (window.location.search.includes('variant=')) {
    const urlWithoutVariant = window.location.href.split('?')[0];
    window.history.replaceState(null, null, urlWithoutVariant);
  }


  const $variantRadios = $('input[name="Joint Discomfort"]'); // Selector for variant radio buttons
  const $swatchElements = $('.jointvar'); // Selector for all swatch elements

  // Uncheck all radio buttons for swatches
  if ($variantRadios.length) {
    $variantRadios.prop('checked', false);
  }

  // Remove the active state from all swatches
  if ($swatchElements.length) {
    $swatchElements.removeClass('selected');
  }

  // 3. Select the first variant swatch and mark it as active
  const $firstSwatch = $('.jointvar:first');
  if ($firstSwatch.length) {
    $firstSwatch.addClass('selected'); // Add the selected class
    $firstSwatch.find('input[name="Joint Discomfort"]').prop('checked', true); // Check the first radio button
  }
});





//   document.addEventListener('DOMContentLoaded', function () {
//   const hotspots = document.querySelectorAll('.hotspot');
  
//   hotspots.forEach(hotspot => {
//     hotspot.addEventListener('mouseenter', function () {
//       const title = this.dataset.title;
//       const description = this.dataset.description;
//       // Display the tooltip or description dynamically
//       const tooltip = document.createElement('div');
//       tooltip.className = 'hotspot-tooltip';
//       tooltip.innerHTML = `<h4>${title}</h4><p>${description}</p>`;
//       document.body.appendChild(tooltip);

//       const rect = this.getBoundingClientRect();
//       tooltip.style.left = `${rect.left + window.pageXOffset}px`;
//       tooltip.style.top = `${rect.top + window.pageYOffset - tooltip.offsetHeight}px`;
//     });

//     hotspot.addEventListener('mouseleave', function () {
//       const tooltip = document.querySelector('.hotspot-tooltip');
//       if (tooltip) tooltip.remove();
//     });
//   });
// });


$(document).ready(function () {
  
  $('.image-with-hotspots .hotspot-container .hotspot-item:first-child').addClass('active');

  $('.image-with-hotspots .hotspot-container .hotspot-item').on('mouseenter', function () {
    $('.image-with-hotspots .hotspot-container .hotspot-item').removeClass('active');
    $(this).addClass('active');
  });
  
});


$(document).ready(function(){
	const line1 = document.querySelector(".vc-line.is-1");

	const line2 = document.querySelector(".vc-line.is-2");
	line2.style.strokeDasharray = line2.getTotalLength();
  	line2.style.strokeDashoffset = line2.getTotalLength();

	const line3 = document.querySelector(".vc-line.is-3");
	line3.style.strokeDasharray = line3.getTotalLength();
  	line3.style.strokeDashoffset = line3.getTotalLength();

	const line4 = document.querySelector(".vc-line.is-4");
	line4.style.strokeDasharray = line4.getTotalLength();
  	line4.style.strokeDashoffset = line4.getTotalLength();

  	function chart(id) {

		if(id == 1) {
			line2.style.strokeDasharray = line2.getTotalLength();
  			line2.style.strokeDashoffset = line2.getTotalLength();

			line3.style.strokeDasharray = line3.getTotalLength();
  			line3.style.strokeDashoffset = line3.getTotalLength();

			line4.style.strokeDasharray = line4.getTotalLength();
  			line4.style.strokeDashoffset = line4.getTotalLength();

  			gsap.set('.vc-dot.is-2, .vc-dot.is-3, .vc-dot.is-4', { fill: '#1B61BE' })
		}

		if(id == 2) {
			line3.style.strokeDasharray = line3.getTotalLength();
  			line3.style.strokeDashoffset = line3.getTotalLength();

			line4.style.strokeDasharray = line4.getTotalLength();
  			line4.style.strokeDashoffset = line4.getTotalLength();

			gsap.set('.vc-line.is-1', { strokeDashoffset: 0, opacity: 1 } )
			gsap.set('.vc-dot.is-1', { fill: '#fff' })

  			gsap.set('.vc-dot.is-3, .vc-dot.is-4', { fill: '#1B61BE' })
		}

		if(id == 3) {
			line4.style.strokeDasharray = line4.getTotalLength();
  			line4.style.strokeDashoffset = line4.getTotalLength();

			gsap.set('.vc-line.is-1, .vc-line.is-2', { strokeDashoffset: 0, opacity: 1 } )
			gsap.set('.vc-dot.is-1, .vc-dot.is-2', { fill: '#fff' })

  			gsap.set('.vc-dot.is-4', { fill: '#1B61BE' })
		}

		if(id == 4) {
			gsap.set('.vc-line.is-1, .vc-line.is-2, .vc-line.is-3', { strokeDashoffset: 0, opacity: 1 } )
			gsap.set('.vc-dot.is-1, .vc-dot.is-2, .vc-dot.is-3', { fill: '#fff' })
		}

		gsap.timeline({})
		.set('.vc-box,.vc-line, .vc-label, .vc-content', { opacity: 0 })
        .set('.vc-dot', { fill: '#0c5cb3' })
		.to('.vc-line.is-'+id, { opacity: 1 })
		.to('.vc-label.is-'+id, { opacity: 1 }, '<')
		.to('.vc-content.is-'+id, { opacity: 1 }, '<')
		.to('.vc-line.is-'+id, { strokeDashoffset: 0, duration: 0.5, ease: "power1.inOut" }, '-=0.5')
		.to('.vc-dot.is-'+id, { fill: '#fff' }, '<')
		.to('.vc-box.is-'+id, { opacity: 1, duration: 0.2 }, '<')
        if (id > 1) {
        gsap.to('.vc-dot.is-' + (id - 1), { fill: '#fff' });
        }
  	}

	$('.vc-dot.is-1').on('click', function(){ chart(1) })
	$('.vc-dot.is-2').on('click', function(){ chart(2) })
	$('.vc-dot.is-3').on('click', function(){ chart(3) })
	$('.vc-dot.is-4').on('click', function(){ chart(4) })



});








document.addEventListener('DOMContentLoaded', function () {
  var accordions = document.querySelectorAll('.menu-drawer__accordion-item');

  accordions.forEach(function (detailsEl) {
    detailsEl.addEventListener('toggle', function () {
      var summary = detailsEl.querySelector('summary');
      if (!summary) return;

      if (detailsEl.open) {
        summary.classList.add('menu-drawer__menu-item--active');
      } else {
        summary.classList.remove('menu-drawer__menu-item--active');
      }
    });
  });
});